import type { BankName } from "@/api/custom_types";

const BANK_NAMES = {
	ayande: true,
	dey: true,
	eghtesad_novin: true,
	gardeshgari: true,
	gharz_ol_hasane_mehr_iran: true,
	iranzamin: true,
	kar_afarin: true,
	keshavarzi: true,
	markazi: true,
	maskan: true,
	mellat: true,
	melli: true,
	moassese_etebari_tosee: true,
	parsian: true,
	pasargad: true,
	post_iran: true,
	refah_kargaran: true,
	saderat_iran: true,
	saman: true,
	sanat_o_madan: true,
	sarmaye: true,
	sepah: true,
	shahr: true,
	sina: true,
	tejarat: true,
	tosee_saderat_iran: true,
	tosee_taavon: true,
	iran_o_venezuela: true,
	khavare_miyane: true,
	melal: true,
	noor: true,
	resalat: true,
	unknown: true,
} satisfies Record<BankName, true>;

export const ALL_BANKS = Object.keys(BANK_NAMES) as BankName[];
